export const floatToFixed = (value) => Math.round(value * 100) / 100;
